import React, { useState, useEffect } from 'react';
import InputAutoSuggest from 'react-input-autosuggest'
//import 'react-input-autosuggest/dist/index.css'
import { NavbarBrand, Navbar, Progress, Container, Col, Row, Nav, NavItem, NavLink, TabContent, TabPane, Button, Input } from 'reactstrap';
import {
  Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle,
} from 'reactstrap';
import classnames from 'classnames';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import latest_thumbnail from './latest_thumbnail.png'

var commodities = {9850:["Spirits",0.2],
                   43:["Antibiotics",0.5],
                   3717:["Dairy Products",0.5],
                   3715:["Frozen Food",0.5],
                   45:["Frozen Plant Seeds",0.5],
                   3647:["Holoreels",0.5],
                   12478:["Khumaak",0.3],
                   3777:["Long-limb Roes",1],
                   11855:["Protein Delicacies",0.5],
                   3699:["Quafe",0.1],
                   42:["Spiced Wine",0.5],
                   9852:["Tobacco",0.2],
                   3673:["Wheat",1.15],
                   3812:["Data Sheets",1],
                   3687:["Electronic Parts",1],
                   41:["Garbage",0.25],
                   3773:["Hydrochloric Acid",0.5],
                   3685:["Hydrogen Batteries",1],
                   3643:["Soil",1.5],
                   3713:["Vitoc",0.5],
                   3723:["Slaver Hound",1],
                   3729:["Toxic Waste",1],
                   3721:["Slaves",5]
                 };


var empire_regions = [10000054, 10000036, 10000043, 10000067, 10000052, 10000065, 10000020, 10000038,
                     10000016, 10000033, 10000002,
                     10000064, 10000037, 10000048, 10000032, 10000044, 10000068,
                     10000042, 10000030, 10000028,
                     10000049, 10000001];

var mineraldata = JSON.parse("[{\"ore\":1230,\"composition\":[{\"mineral\":34,\"quantity\":415},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1228,\"composition\":[{\"mineral\":34,\"quantity\":346},{\"mineral\":35,\"quantity\":173},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1224,\"composition\":[{\"mineral\":34,\"quantity\":351},{\"mineral\":35,\"quantity\":25},{\"mineral\":36,\"quantity\":50},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":5},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":18,\"composition\":[{\"mineral\":34,\"quantity\":107},{\"mineral\":35,\"quantity\":213},{\"mineral\":36,\"quantity\":107},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1227,\"composition\":[{\"mineral\":34,\"quantity\":800},{\"mineral\":35,\"quantity\":100},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":85},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":20,\"composition\":[{\"mineral\":34,\"quantity\":134},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":267},{\"mineral\":37,\"quantity\":134},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1226,\"composition\":[{\"mineral\":34,\"quantity\":0},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":350},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":75},{\"mineral\":39,\"quantity\":8},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1231,\"composition\":[{\"mineral\":34,\"quantity\":2200},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":100},{\"mineral\":38,\"quantity\":120},{\"mineral\":39,\"quantity\":15},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":21,\"composition\":[{\"mineral\":34,\"quantity\":0},{\"mineral\":35,\"quantity\":1000},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":200},{\"mineral\":38,\"quantity\":100},{\"mineral\":39,\"quantity\":19},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1229,\"composition\":[{\"mineral\":34,\"quantity\":0},{\"mineral\":35,\"quantity\":2200},{\"mineral\":36,\"quantity\":2400},{\"mineral\":37,\"quantity\":300},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1232,\"composition\":[{\"mineral\":34,\"quantity\":10000},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":1600},{\"mineral\":38,\"quantity\":120},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1225,\"composition\":[{\"mineral\":34,\"quantity\":21000},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":760},{\"mineral\":39,\"quantity\":135},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":19,\"composition\":[{\"mineral\":34,\"quantity\":56000},{\"mineral\":35,\"quantity\":12050},{\"mineral\":36,\"quantity\":2100},{\"mineral\":37,\"quantity\":450},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":1223,\"composition\":[{\"mineral\":34,\"quantity\":0},{\"mineral\":35,\"quantity\":12000},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":450},{\"mineral\":40,\"quantity\":100},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":22,\"composition\":[{\"mineral\":34,\"quantity\":22000},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":2500},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":320},{\"mineral\":11399,\"quantity\":0}]},{\"ore\":11396,\"composition\":[{\"mineral\":34,\"quantity\":0},{\"mineral\":35,\"quantity\":0},{\"mineral\":36,\"quantity\":0},{\"mineral\":37,\"quantity\":0},{\"mineral\":38,\"quantity\":0},{\"mineral\":39,\"quantity\":0},{\"mineral\":40,\"quantity\":0},{\"mineral\":11399,\"quantity\":300}]}]");
var ore_flavors = {22: {plus_5: 17425, plus_10: 17426},
                   1223: {plus_5: 17428, plus_10: 17429},
                   1224: {plus_5: 17459, plus_10: 17460},
                   18: {plus_5: 17455, plus_10: 17456},
                   19: {plus_5: 17466, plus_10: 17467},
                   1230: {plus_5: 17470, plus_10: 17471},
                   1228: {plus_5: 17463, plus_10: 17464},
                   1225: {plus_5: 17432, plus_10: 17433},
                   1232: {plus_5: 17436, plus_10: 17437},
                   20: {plus_5: 17452, plus_10: 17453},
                   1229: {plus_5: 17865, plus_10: 17866},
                   1227: {plus_5: 17867, plus_10: 17868},
                   21: {plus_5: 17440, plus_10: 17441},
                   1231: {plus_5: 17444, plus_10: 17445},
                   1226: {plus_5: 17448, plus_10: 17449},
                   11396: {plus_5: 17869, plus_10: 17870}};
var compressed_ores = []

function makeAjax(url, cb)
{
  return fetch(url)
          .then(response => cb(response.json(), response.statusText, response.headers));
}

function ajaxPost(url, json_data, cb)
{
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: json_data
  };
  fetch(url, requestOptions)
        .then(response => response.json())
        .then(x => cb(x))
}

function range(start, end)
{
    return Array.from(Array(end + 1).keys()).filter(x => (x >= start));
}

async function loadMultipageQuery(url)
{
    //'https://esi.tech.ccp.is/latest/markets/10000067/orders/?datasource=tranquility&type_id=3687&page=1'

    while (true)
    {
      try
      {
        let result = await makeAjax(url+'&page=1', (data, textStatus, header) => {
                var pagecnt = header['x-pages'];
                //console.log(pagecnt);
                if (pagecnt > 1)
                {
                    return Promise.all(range(2,pagecnt).map(pagenum => makeAjax(url+'&page='+pagenum, (x)=>x))).then(datas => datas.reduce((x,y) => x.concat(y), data))
                }
                else
                    return data;
            })
        return result;
      }
      catch (e)
      {
        console.error(e)
        await new Promise(r => setTimeout(r, 5000));
      }
    }
}

function queryPrice(typeid, region, location)
{
    return loadMultipageQuery('https://esi.evetech.net/latest/markets/'+region+'/orders/?datasource=tranquility&type_id='+typeid)
        .then(data => data.filter(x => (!x.is_buy_order && x.location_id == location))
                          .sort((x, y) => (x.price - y.price))
                          .reduce((x, y) => ((x.total_cost < 50000000)?{total_cost: x.total_cost + y.price*y.volume_remain, tota_cnt: x.tota_cnt + y.volume_remain}:x), {total_cost: 0, tota_cnt: 0}))
        .then(x => ({id: typeid, price: x.total_cost/x.tota_cnt}))
}

var orders_cache = {}

async function queryNPCOrdersInEmpires(typeid)
{
    if (orders_cache[typeid])
    {
        if (Date.now() - orders_cache[typeid].time < 300000)
        {
          return orders_cache[typeid].data;
        }
    }

    var orders_by_regions = Promise.all(empire_regions.map((region) => loadMultipageQuery('https://esi.evetech.net/latest/markets/'+region+'/orders/?datasource=tranquility&type_id='+typeid)))
    var orders = [].concat.apply([], await orders_by_regions);
    //console.log(orders)
    var max_sell_volume = 0;
    var max_buy_volume = 0;
    var max_buy_price = 0;
    var min_sell_price = 100000000000000000;

    var sell_orders = orders.filter(x => (!x.is_buy_order && x.duration === 365));
    var buy_orders = orders.filter(x => (x.is_buy_order && x.duration === 365));
    sell_orders.map((x) => {
      if (x.volume_remain > max_sell_volume)
      {
        max_sell_volume = x.volume_remain;
      }
      if (x.price < min_sell_price)
      {
        min_sell_price = x.price ;
      }
    })
    buy_orders.map((x) => {
      if (x.volume_remain > max_buy_volume)
      {
        max_buy_volume = x.volume_remain;
      }
      if (x.price > max_buy_price)
      {
        max_buy_price = x.price ;
      }
    })

    sell_orders = sell_orders.filter(x => (x.price < max_buy_price));
    buy_orders = buy_orders.filter(x => (x.price > min_sell_price));
    sell_orders = sell_orders.filter(x => (x.volume_remain > 0.2*max_sell_volume));
    buy_orders = buy_orders.filter(x => (x.volume_remain > 0.2*max_buy_volume));


    orders_cache[typeid] = {time:Date.now(), data: [sell_orders, buy_orders]}
    return [sell_orders, buy_orders];
}

async function queryOrdersByLocation(typeid, region, threshold)
{
    var orders = await loadMultipageQuery('https://esi.evetech.net/latest/markets/'+region+'/orders/?datasource=tranquility&type_id='+typeid)
        .then(data => data.filter(x => (!x.is_buy_order && x.price < threshold))
                          .sort((x, y) => (x.price - y.price)));

    var stations = orders.reduce((x, y) => x.add(y.location_id), new Set());

    var station_volume = []
    stations.forEach((v1,v2,s) => {station_volume.push([v1, orders.filter(x => x.location_id == v1)
                                                             .reduce((x, y) => ({oreid: typeid, total_cost: x.total_cost + y.price*y.volume_remain, total_cnt: x.tota_cnt + y.volume_remain}), {total_cost: 0, tota_cnt: 0})
                                                             ])});
    return station_volume;
}

async function getStationJumps(id)
{
    var info = await makeAjax('https://esi.evetech.net/latest/universe/stations/'+id+'/?datasource=tranquility', stinfo => [stinfo.name, stinfo.system_id]);

    var route = await makeAjax('https://esi.evetech.net/latest/route/30002188/'+info[1]+'/?datasource=tranquility&flag=shortest', (x) => x);
    return [info[0], route];
}

async function finalizeReport(ndata, stations_orders, stations_total, types, setReportData)
{
    var names = ndata.reduce((x, y) => {x[y.id]= y.name; return x; }, {});
    stations_total.sort((x,y)=>y[1]-x[1])


    var jumps = await Promise.all(stations_total.map(st => getStationJumps(st[0])));
    console.log(jumps)
        //
    var data = stations_total.map(st => [names[st[0]], jumps.filter(x=>x[0]==names[st[0]]).map(x=> x[1])[0], st[1], stations_orders.filter(x => x[0] == st[0]).map(x => [types[x[1].oreid], x[1].total_cost, x[1].total_cost/x[1].total_cnt])])
    console.log(data)
    setReportData(data)
    //$('#ore_report').html('<table>'+data.map(x => '<tr><td>'+[x[0],x[2],x[3].join('<br>')].join('</td><td>')+'</td></tr>').join('')+'</table>')
}

async function processNamesAndRun(data, region, setReportData)
{
    var names = data.reduce((x, y) => {x[y.id]= y.name; return x; }, {});
    var mineral_prices = await Promise.all(minerals.map(x => queryPrice(x, 10000002, 60003760)))
        .then(x=> x.map((z) => {z.name = names[z.id]; return z;})
                               .reduce((a, x)=> {a[x.id] = x; return a;}, []))
    //[x.ore, ore_flavors[x.ore].plus_5, ore_flavors[x.ore].plus_10]
    var r=[]
    mineraldata.map(x => {r.push([x.ore, names[x.ore], x.composition.reduce((tot, mine) => tot + mine.quantity * mineral_prices[mine.mineral].price/100, 0)*refinerate]);
                          r.push([ore_flavors[x.ore].plus_5, names[ore_flavors[x.ore].plus_5], 1.05*x.composition.reduce((tot, mine) => tot + mine.quantity * mineral_prices[mine.mineral].price/100, 0)*refinerate]);
                          r.push([ore_flavors[x.ore].plus_10, names[ore_flavors[x.ore].plus_10], 1.10*x.composition.reduce((tot, mine) => tot + mine.quantity * mineral_prices[mine.mineral].price/100, 0)*refinerate]);
                          });

    var allstations = await Promise.all(r.map(x=> queryOrdersByLocation(x[0], region, x[2]))).then(x=>x.reduce((x,y) => x.concat(y)));
    var stations = Array.from(allstations.reduce((x, y) => x.add(y[0]), new Set()));
    var totals = stations.map(stid => [stid, allstations.filter(x => x[0] == stid).reduce((x,y) => x + y[1].total_cost, 0)])
    ajaxPost('https://esi.evetech.net/latest/universe/names/?datasource=tranquility',
              JSON.stringify(stations),
              x=>finalizeReport(x, allstations, totals, names, setReportData))
}
//
var refinerate = 0.7;
var minerals=[34,35,36,37,38,39,40,11399];

var allIds = mineraldata.map(x => [x.ore, ore_flavors[x.ore].plus_5, ore_flavors[x.ore].plus_10]).reduce((x,y)=>x.concat(y),minerals)


function Market() {
    var [reportData, setReportData] = useState([]);
    const [systemRange,setSystemRange]=useState([]);
    const [systemRangeLS,setSystemRangeLS]=useState([]);
    const [selectedRangeDB,setSelectedRangeDB]=useState("HS");
    const [systemName,setSystemName]=useState('');
    const [systemNameToId,setSystemNameToId]=useState([]);
    const [systemIdToName,setSystemIdToName]=useState([]);
    const [systemAutocomplete,setSystemAutocomplete]=useState([]);
    const [startSystemId,setStartSystemId]=useState(0);
    const [calculationResult,setCalculationResult]=useState([-1, [0, 0, 0]]);
    const [selectedWareId,setSelectedWareId]=useState(0);
    const [calculationProgress,setCalculationProgress]=useState(-1);
    const [maxCargo,setMaxCargo]=useState(20000);
    const [maxValue,setMaxValue]=useState(60);
    const [taxRate,setTaxRate]=useState(8);
    const [activeTab,setActiveTab]=useState('1');
    const [multiWares, setMultiWares]=useState([]);
    const [processedWare, setProcessedWare]=useState(-1);
    const [multiResult, setMultiResult]=useState([]);
    useEffect(()=>{
      fetch('ls_hs_system_to_system_range.json'
          ,{headers : {'Content-Type': 'application/json',
                       'Accept': 'application/json' }
          })
        .then(r => r.json())
        .then(j => setSystemRangeLS(j))
      fetch('hs_only_system_to_system_range.json'
          ,{headers : {'Content-Type': 'application/json',
                       'Accept': 'application/json' }
          })
        .then(r => r.json())
        .then(j => setSystemRange(j))
      fetch('system_to_id.json'
          ,{headers : {'Content-Type': 'application/json',
                       'Accept': 'application/json' }
          })
        .then(r => r.json())
        .then(j => {
          let result = {}
          Object.keys(j).map((x) => {
            result[x.toUpperCase()] = j[x];
          })
          setSystemNameToId(result)
        })
      fetch('id_to_system.json'
          ,{headers : {'Content-Type': 'application/json',
                       'Accept': 'application/json' }
          })
        .then(r => r.json())
        .then(j => setSystemIdToName(j))
      fetch('system_autocomplete.json'
          ,{headers : {'Content-Type': 'application/json',
                       'Accept': 'application/json' }
          })
        .then(r => r.json())
        .then(j => setSystemAutocomplete(j))
    },[])

    const toggle = tab => {
      if(activeTab !== tab) setActiveTab(tab);
    }

    const findBestRoute = async (orders, start) =>
    {
      let maxVolume = maxCargo;
      let maxPrice = maxValue*1000000;
      var [sell_orders, buy_orders] = orders;
      let length = -1;
      let profit = 0;
      let bestProfitPerJump = 0;
      let shortest_systems = [];
      let bestOperationItemCount = 0;
      let bestOperationItemVolume = 0;
      let range_db = systemRange;

      if (selectedRangeDB == "HS")
      {
        range_db = systemRange;
      } else if (selectedRangeDB == "LS")
      {
        range_db = systemRangeLS;
      }

      for (let i = 0; i < sell_orders.length; i++){
        let so = sell_orders[i]
        setCalculationProgress(i/sell_orders.length)
        await new Promise(r => setTimeout(r, 50));
        buy_orders.map(bo => {
          console.log(start,so.system_id,bo.system_id)
          var range = 2;
          if (so.system_id !== start)
          {
            console.log('sell start',range_db[so.system_id][start])
            if (!(range_db[so.system_id][start] > -1))
            {
                return;
            }
            range += range_db[so.system_id][start]
          }
          if (so.system_id !== bo.system_id)
          {
            //console.log('sell buy',range_db[so.system_id][bo.system_id])
            if (!(range_db[so.system_id][bo.system_id] > -1))
            {
                return;
            }
            range += range_db[so.system_id][bo.system_id]
          }
          //console.log(range, range_db[so.system_id][start], range_db[so.system_id][bo.system_id])
          if (!(range > -1))
          {
            return;
          }
          let maxVolumeFromCost = Math.floor(maxPrice / so.price);
          let maxVolumeFromCargo = Math.floor(maxVolume / commodities[so.type_id][1]);
          let operationItemCount = Math.min(so.volume_remain, bo.volume_remain, maxVolumeFromCost, maxVolumeFromCargo);
          let operationItemVolume = operationItemCount*commodities[so.type_id][1].toFixed(1);
          let profitPerJump = (bo.price * (100 - taxRate)/100 - so.price) * Math.min(so.volume_remain, bo.volume_remain, maxVolumeFromCost, maxVolumeFromCargo) / range;
          if (bestProfitPerJump < profitPerJump)
          {
            bestOperationItemCount = operationItemCount;
            bestOperationItemVolume = operationItemVolume;
            bestProfitPerJump = profitPerJump;
            length = range;
            shortest_systems = [start,so.system_id,bo.system_id, so.location_id, bo.location_id,
                                so.price, so.volume_remain, bo.price, bo.volume_remain];
          }
        })
      }
      setCalculationProgress(1)
      //console.log([length, shortest_systems, bestProfitPerJump, length * bestProfitPerJump, bestOperationItemCount, bestOperationItemVolume])
      return [length, shortest_systems, bestProfitPerJump, length * bestProfitPerJump, bestOperationItemCount, bestOperationItemVolume]
    }

  return (
    <Container style={{minHeight:"100vh", padding:"2rem"}}>
    <Col sm="12" lg={{size:8, offset:2}} xl={{size:6, offset:3}} style={{background: "#406AB2", borderRadius:"1rem", opacity:"80%"}}>
    <Nav tabs>
    <NavItem>
      <NavLink
        className={classnames({ active: activeTab === '1' })}
        onClick={() => { toggle('1'); }}
        style={{color: "#E3D370", fontSize:"1.2rem"}}
      >
        <b>Single commodity search</b>
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        className={classnames({ active: activeTab === '2' })}
        onClick={() => { toggle('2'); }}
        style={{color: "#E3D370", fontSize:"1.2rem"}}
      >
       <b>Multiple commodity search</b>
      </NavLink>
    </NavItem>
  </Nav>

    <TabContent activeTab={activeTab}>
    <TabPane tabId="1"
    style={{paddind:"0.3rem", color: "#E3D370"}}>
    <div id="ore_report" className="padded three quarters info">
        <Row className="d-flex justify-content-between align-items-center" style={{margin:"0.6rem"}}>Tax rate, %: <Input style={{width: "50%"}} type="number" min={0} max={25} step={0.1} value={taxRate} onChange={(x) => setTaxRate(x.target.value)}></Input></Row>
      <Row className="d-flex justify-content-between align-items-center"  style={{margin:"0.6rem"}}>Max cargo volume, m3: <Input style={{width: "50%"}} type="number" min={0} max={2000000} step={1} value={maxCargo} onChange={(x) => setMaxCargo(x.target.value)}></Input></Row>
    <Row className="d-flex justify-content-between align-items-center"  style={{margin:"0.6rem"}}>Max cargo value, MISK: <Input style={{width: "50%"}} type="number" min={0} max={2000} step={0.01} value={maxValue} onChange={(x) => setMaxValue(x.target.value)}></Input></Row>
  <Row className="d-flex justify-content-between align-items-center"  style={{margin:"0.6rem"}}>Start system:

    <div className=""  style={{width:"50%", padding:"0", color:"black"}}>
    <InputAutoSuggest
        style={{width:"100%"}}
        name="system"
        value={systemName}
        onChange={(x) => {
          //console.log(x)
          if (x.target.value.trim)
          {
            setSystemName(x.target.value)
            if (systemNameToId[x.target.value.trim().toUpperCase()])
            {
            setStartSystemId(systemNameToId[x.target.value.trim().toUpperCase()])

            }
          }
          }}
        data={systemAutocomplete.map(x=>x['name'])}

    /></div></Row>
        <div className="d-flex justify-content-between align-items-center" style={{paddind:"0.3rem"}} style={{margin:"0.3rem"}} >
        Routing:
        <select  style={{margin:"0.3rem"}} name="product" className="unselected" defaultValue=""
                onChange={x2 => setSelectedRangeDB(x2.target.value)}>
                <option value={"HS"} selected="selected">High Security only</option>
                <option value={"LS"} selected="selected">(Dangerous!) Allow low security systems</option>
          </select></div>
        <div className="d-flex justify-content-between align-items-center" style={{paddind:"0.3rem"}} style={{margin:"0.3rem"}} >
        Product:
        <select  style={{margin:"0.3rem"}} name="product" className="unselected" defaultValue=""
                onChange={x2 => setSelectedWareId(x2.target.value)}>
                <option value={0} selected="selected"></option>
                    {
                      Object.keys(commodities).map((x) =>
                            (<option value={x} key={x}>
                              {commodities[x][0]}
                            </option>))
                    }
          </select></div>
        <Button color="warning" style={{margin:"0.3rem"}} onClick={()=>{
                                if (startSystemId === 0 || selectedWareId === 0)
                                {
                                  alert("You need to select the product and your location")
                                  return;
                                }
                                setCalculationProgress(0)
                                queryNPCOrdersInEmpires(selectedWareId)
                                .then((x) => findBestRoute(x, startSystemId))
                                .then(setCalculationResult)
                              }}>Find the best route</Button>
                            {calculationProgress == 1 ? (calculationResult[0] >= 0 ? (
                              <div style={{fontSize:"1.5rem", padding:"1rem"}}>
            <div style={{paddind:"0.3rem", color:"white"}}>
              Best route:
            </div>
            <div style={{paddind:"0.3rem", color:"white"}}>
              {calculationResult[0]} jump(s):<br/>
              {systemIdToName[calculationResult[1][0]]}<br/>
            => {systemIdToName[calculationResult[1][1]]} (x{calculationResult[1][6]} @ {calculationResult[1][5]} ISK/item)<br/>
            => {systemIdToName[calculationResult[1][2]]} (x{calculationResult[1][8]} @ {calculationResult[1][7]} ISK/item)
            </div>
            <div style={{paddind:"0.3rem", color:"white"}}>
              Trading: {(calculationResult[4])} units ({(calculationResult[5]).toFixed(2)} m3)
            </div>
            <div style={{paddind:"0.3rem", color:"white"}}>
              Profit: {(calculationResult[3]/1000000).toFixed(2)} MISK Profit per jump:  {(calculationResult[2]/1000000).toFixed(2)} MISK
            </div>
          </div>): (<div style={{paddind:"0.3rem", color:"white"}}>No profitable route found</div>)) : (calculationProgress > 0 ?
            (<Progress  max={100} color="success" value={calculationProgress*100}/>) :
          (calculationProgress === 0 ? (<div>Downloading market data from ESI ...</div>): null))}
    </div>
    </TabPane>
    </TabContent>

    <TabContent activeTab={activeTab}>
    <TabPane tabId="2"
    style={{paddind:"0.3rem", color: "#E3D370"}}>
    <div id="ore_report" className="padded three quarters info">
        <Row className="d-flex justify-content-between align-items-center" style={{margin:"0.6rem"}}>Tax rate, %: <Input style={{width: "50%"}} type="number" min={2} max={5} step={0.1} value={taxRate} onChange={(x) => setTaxRate(x.target.value)}></Input></Row>
      <Row className="d-flex justify-content-between align-items-center"  style={{margin:"0.6rem"}}>Max cargo volume, m3: <Input style={{width: "50%"}} type="number" min={0} max={2000000} step={1} value={maxCargo} onChange={(x) => setMaxCargo(x.target.value)}></Input></Row>
    <Row className="d-flex justify-content-between align-items-center"  style={{margin:"0.6rem"}}>Max cargo value, MISK: <Input style={{width: "50%"}} type="number" min={0} max={2000} step={0.01} value={maxValue} onChange={(x) => setMaxValue(x.target.value)}></Input></Row>
    <Row className="d-flex justify-content-between align-items-center"  style={{margin:"0.6rem"}}>Start system:

      <div className=""  style={{width:"50%", padding:"0", color:"black"}}>
      <InputAutoSuggest
          style={{width:"100%"}}
          name="system"
          value={systemName}
          onChange={(x) => {
            console.log(x)
            if (x.target.value.trim)
            {
              setSystemName(x.target.value)
              if (systemNameToId[x.target.value.trim().toUpperCase()])
              {
              setStartSystemId(systemNameToId[x.target.value.trim().toUpperCase()])

              }
            }
            }}
          data={systemAutocomplete.map(x=>x['name'])}

      /></div></Row>
        <div className="d-flex justify-content-between align-items-center" style={{paddind:"0.3rem"}} style={{margin:"0.3rem"}} >
        Routing:
        <select  style={{margin:"0.3rem"}} name="product" className="unselected" defaultValue=""
                onChange={x2 => setSelectedRangeDB(x2.target.value)}>
                <option value={"HS"} selected="selected">High Security only</option>
                <option value={"LS"} selected="selected">(Dangerous!) Allow low security systems</option>
          </select></div>
  <div style={{paddind:"0.3rem"}} style={{margin:"0.3rem", color:"black"}} >
        <span style={{color:"#E3D370"}}>Product:</span>
        <Select
          isMulti={true}
          value={multiWares}
          onChange={x => setMultiWares(x)}
          options={Object.keys(commodities).map(x=> ({value: x, label: commodities[x][0]}))}
        /></div>
      <Button color="info" style={{margin:"0.3rem"}} onClick={()=>
            setMultiWares(Object.keys(commodities).map(x=> ({value: x, label: commodities[x][0]})))
          }>Select all</Button>
        <Button color="warning" style={{margin:"0.3rem"}} onClick={async ()=>{
                                if (startSystemId === 0 || multiWares.length === 0)
                                {
                                  alert("You need to select the product and your location")
                                  return;
                                }
                                let results = [];
                                let processed = 0;
                                setProcessedWare(processed);
                                await new Promise(r => setTimeout(r, 10));
                                let ids = multiWares.map(x => parseInt(x.value))
                                for (let i = 0; i < ids.length; i++) {
                                    let selectedWareId = ids[i];
                                    setCalculationProgress(0);
                                    let r = await queryNPCOrdersInEmpires(selectedWareId)
                                    .then((x) => findBestRoute(x, startSystemId));
                                  if (r[0] > 0)
                                  {
                                    results.push({id:selectedWareId, result:r});
                                  }
                                  processed++;
                                  setProcessedWare(processed);
                                  await new Promise(r => setTimeout(r, 10));
                                  }
                                results = results.sort((a,b) => a.result[2] > b.result[2] ? -1 : (a.result[2] < b.result[2] ? 1 : 0))
                                setMultiResult(results);

                                setProcessedWare(-1);
                              }}>Find the best route</Button>
                            {processedWare > -1 ? (<div> Processing ware {processedWare+1} of {multiWares.length}</div>):null}
                            {calculationProgress == 1 ? (multiResult.length > 0 ? (<div>
                              {multiResult.map(record => {
                                let name = commodities[record.id][0];
                                let calculationResult = record.result;
                                return (
                                  <div style={{fontSize:"1.5rem", padding:"1rem"}}>
                                      <div style={{paddind:"0.3rem", color:"white"}}>
                                        Best route for {name}:
                                      </div>
                                      <div style={{paddind:"0.3rem", color:"white"}}>
                                        {calculationResult[0]} jump(s):<br/>
                                        {systemIdToName[calculationResult[1][0]]}<br/>
                                      => {systemIdToName[calculationResult[1][1]]} (x{calculationResult[1][6]} @ {calculationResult[1][5]} ISK/item)<br/>
                                     => {systemIdToName[calculationResult[1][2]]} (x{calculationResult[1][8]} @ {calculationResult[1][7]} ISK/item)
                                      </div>
                                      <div style={{paddind:"0.3rem", color:"white"}}>
                                        Trading: {(calculationResult[4])} units ({(calculationResult[5]).toFixed(2)} m3)
                                      </div>
                                      <div style={{paddind:"0.3rem", color:"white"}}>
                                        Profit: {(calculationResult[3]/1000000).toFixed(2)} MISK Profit per jump:  {(calculationResult[2]/1000000).toFixed(2)} MISK
                                      </div>
                                    </div>
                                );
                              })}
                          </div>): (<div style={{paddind:"0.3rem", color:"white"}}>No profitable route found</div>)) :
                            (calculationProgress > 0 ?
                              (<Progress   max={100}  color="success" value={calculationProgress*100}/>) :
                            (calculationProgress === 0 ? (<div>Downloading market data from ESI ...</div>): null))}

    </div>
    </TabPane>
  </TabContent>
  <center className="m-2"
        style={{
        	zIndex: -100,
        	position: "relative"
        }}>
      <Card style={{maxWidth: "80%"}}>

        <CardImg src={latest_thumbnail}></CardImg>
      <CardBody>
        <CardTitle>Level up your hauling game in EVE online with market analysis tools. Part 1</CardTitle>
      <Button color="success" onClick={()=> window.open("https://www.youtube.com/watch?v=lIxXnVrRH7U", "_blank")}>Watch on YouTube</Button>
      </CardBody>
      </Card>
    </center>
    <div className="footerSpacer"></div>
    <div className="fixed-bottom responsiveFooter">
        <Navbar color="dark" dark>
            <Container>
                <NavbarBrand className="w-100"><NavLink style={{color: "white"}} className="w-100" href="https://pterippi.fi"><Row className="d-flex w-100 flex-row justify-content-around align-items-center"><Col sm={12} lg={6}><img style={{maxHeight: "5vh", filter: "brightness(0) invert(1)"}} src="https://pterippi.fi/static/media/pterippi-logo.80fae1c3.png"/></Col><Col sm={12} lg={6} className="text-wrap">This tools was developed by Pterippi Oy.<br/>Contact us if you need custom digital tools for your business.</Col></Row></NavLink></NavbarBrand>
              <NavbarBrand className="w-100" className="text-wrap text-muted" style={{fontSize:"0.6rem"}}>2021 (c) Pterippi Oy. All rights reserved. Data is provided by ESI API courtesy of CCP Games. <br/>
              EVE Online and the EVE logo are the registered trademarks of CCP hf. All rights are reserved worldwide.

              All other trademarks are the property of their respective owners. EVE Online, the EVE logo, EVE and all associated logos and designs are the intellectual property of CCP hf. All artwork, screenshots, characters, vehicles, storylines, world facts or other recognizable features of the intellectual property relating to these trademarks are likewise the intellectual property of CCP hf. CCP hf. has granted permission to eveonlineships.com to use EVE Online and all associated logos and designs for promotional and information purposes on its website but does not endorse, and is not in any way affiliated with, eveonlineships.com.

              CCP is in no way responsible for the content on or functioning of this website, nor can it be liable for any damage arising from the use of this website.
        </NavbarBrand>
            </Container>
        </Navbar>
    </div>
  </Col>
  </Container>
  );
}

export default Market;



// WEBPACK FOOTER //
// ./src/market.js